<template>
  <div class="p-4 text-center">
    <div class="text-lg font-semibold mb-4">Aviso: Link Externo</div>

    <svg width="162" height="84" viewBox="0 0 162 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 0.5H118C118.828 0.5 119.5 1.17157 119.5 2V82C119.5 82.8284 118.828 83.5 118 83.5H2C1.17157 83.5 0.5 82.8284 0.5 82V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
        fill="white" stroke="#828282" />
      <line y1="6.5" x2="120" y2="6.5" stroke="#828282" />
      <circle cx="4.5" cy="3.5" r="1.5" fill="#D9D9D9" />
      <circle cx="9.5" cy="3.5" r="1.5" fill="#D9D9D9" />
      <circle cx="14.5" cy="3.5" r="1.5" fill="#D9D9D9" />
      <rect x="21" y="2" width="71" height="3" rx="1" fill="#D9D9D9" />
      <rect x="6" y="12" width="78" height="33" fill="#F5F5F5" />
      <rect x="6" y="49" width="78" height="4" fill="#F5F5F5" />
      <rect x="6" y="57" width="78" height="4" fill="#F5F5F5" />
      <rect x="6" y="65" width="24" height="15" fill="#F5F5F5" />
      <rect x="33" y="65" width="24" height="15" fill="#F5F5F5" />
      <rect x="60" y="65" width="24" height="15" fill="#F5F5F5" />
      <rect x="91" y="12" width="24" height="15" fill="#F5F5F5" />
      <rect x="91" y="30" width="24" height="15" fill="#F5F5F5" />
      <rect x="91" y="48" width="24" height="32" fill="#F5F5F5" />
      <path
        d="M103 13.5H161C161.276 13.5 161.5 13.7239 161.5 14V54C161.5 54.2761 161.276 54.5 161 54.5H103C102.724 54.5 102.5 54.2761 102.5 54V14C102.5 13.7239 102.724 13.5 103 13.5Z"
        fill="white" stroke="#828282" />
      <line x1="102" y1="18" x2="162" y2="18" stroke="#828282" />
      <circle cx="104.25" cy="15.75" r="0.75" fill="#D9D9D9" />
      <circle cx="106.75" cy="15.75" r="0.75" fill="#D9D9D9" />
      <circle cx="109.25" cy="15.75" r="0.75" fill="#D9D9D9" />
      <rect x="112.5" y="15" width="35.5" height="1.5" rx="0.75" fill="#D9D9D9" />
      <g filter="url(#filter0_f_1240_2356)">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M97.75 54.3827L118 42.6913L97.75 31V36.1918C79.3516 36.2619 63.4707 44.0765 57 60.9999C65.2056 49.1474 79.8626 49.2653 93.9354 49.3784C95.2135 49.3887 96.4868 49.3989 97.75 49.4002V54.3827Z"
          fill="black" fill-opacity="0.2" />
      </g>
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M97.75 46.1913L118 34.4999L97.75 22.8086V28.0009C79.2936 28.1371 57 43.3187 57 60.9999C66.4481 44.5901 82.5835 41.2453 97.75 41.2092V46.1913Z"
        fill="#F7CD3B" />
      <defs>
        <filter id="filter0_f_1240_2356" x="53" y="27" width="69" height="37.9999" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_1240_2356" />
        </filter>
      </defs>
    </svg>
    <div class="my-4 max-w-[420px] mx-auto text-sm text-neutral-500 dark:text-neutral-400 italic">
      {{ $t('feedback.externalLink') }}
    </div>

    <UiButton
      type="primary"
      class="px-4 py-2"
      @click="openLink"
    >{{ $t('button.access') }}</UiButton>
  </div>
</template>

<script setup lang="ts">
import UiButton from '@/components/ui/button.vue'

const { url } = defineProps<{
  url: string
}>()

const openLink = () => {
  window.open(url, '_blank')
}
</script>
